<template>
    <div class="main-container" style="padding-top:5px">
        <p class="title">{{ item.owerName }}继续率规则</p>
        <div class="form">
            <div class="form-item" v-if="formData.netReceipts && formData.netReceipts.length">
                <span class="label">实收保费</span>
                <span class="value">
                    <span v-for="(i, idx) in formData.netReceipts" :key="idx"
                        >{{ netReceiptsMap[i] }} {{ idx == formData.netReceipts.length - 1 ? '' : '，' }}</span
                    >
                </span>
            </div>
            <div class="form-item" v-if="formData.underwrite && formData.underwrite.length">
                <span class="label">承保保费</span>
                <span class="value">
                    <span v-for="(i, idx) in formData.underwrite" :key="idx"
                        >{{ underwriteMap[i] }} {{ idx == formData.underwrite.length - 1 ? '' : '，' }}</span
                    ></span
                >
            </div>
            <div class="form-item">
                <span class="label">计算方式</span>
                <span class="value">{{ formData.calculateType == 1 ? '按承保' : '按实收' }}</span>
            </div>
            <div class="form-item">
                <span class="label">承保保费计入时间</span>
                <span class="value">{{ formData.chargedTime == 1 ? '承保日期' : '生效日期' }}</span>
            </div>
            <div class="form-item">
                <span class="label">沿用上年度实收</span>
                <span class="value">{{ formData.isLastYear == 1 ? '是' : '否' }}</span>
            </div>
        </div>
        <p class="sub-title">除外产品</p>
        <div class="table-box">
            <loading :isShow="listLoading" />
            <Table width="480" max-height="200" :columns="columns" :data="tableData"> </Table>
        </div>
    </div>
</template>

<script>
import { number_format } from '@/api/filter';
import { pageTool } from '@/api/mixins';
export default {
    mixins: [pageTool],
    components: {},
    props: {
        detail: {
            type: Object
        },
        item: {
            type: Object
        }
    },
    data() {
        return {
            formData: {},
            tableData: [],
            netReceiptsMap: {
                '1': '包含附加险',
                '2': '不含理赔终止件',
                '3': '不含转换终止件',
                '4': '不含满期终止件'
            },
            underwriteMap: {
                '1': '包含附加险',
                '2': '不含理赔终止件',
                '3': '不含转换终止件',
                '4': '不含满期终止件',
                '5': '不含犹豫期内退保件'
            },
            columns: [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: '80'
                },
                {
                    title: '产品',
                    key: 'productName',
                    align: 'center'
                },
                {
                    title: '剔除年限',
                    key: 'payTimeDesc',
                    align: 'center',
                    render(h,params) {
                        return (
                            <span>{params.row.payTimeDesc || '-'}</span>
                        )
                    },
                }
            ]
        };
    },
    watch: {
        detail: {
            handler(newVal) {
                if (newVal) {
                    this.formData = newVal;
                    this.tableData = newVal.continuityFilterProductList;
                } else {
                    this.formData = {};
                    this.tableData = [];
                }
            },
            immediate: true, //刷新加载 立马触发一次handler
            deep: true // 可以深度检测到 person 对象的属性值的变化
        },
        visible(newVal) {
            if (!newVal) {
                this.$refs.form.resetFields();
            }
        }
    },

    computed: {},
    created() {},
    open() {
        this.queryParams = this.$route.query;
        this.searchParams.calculateType = this.$route.query.type;
        this.searchParams.rateId = this.$route.query.id;
        this.searchParams.receiptTimeBegin = this.$route.query.receiptTimeBegin;
        this.searchParams.receiptTimeEnd = this.$route.query.receiptTimeEnd;
        this.searchParams.owerId = this.$route.query.owerId;
        this.formParams.isAgain = isAgain;
        this.init();
        this.visible = true;
    },
    methods: {
        submit() {},
        init() {
            this.tableData = [];
            this.getColumns();
            this.initListAjax('/buz/continuityRatePolicy/read/list');
        },
        // 转化参数
        setListParams(params) {}
    }
};
</script>
<style lang="scss" scoped>
@import '../policyList.scss';
.main-container,
.table-box {
    width: 500px;
}
.title {
    // font-size: 16px;
    color: #272933;
    font-weight: bold;
}
.sub-title {
    color: #272933;
    padding-bottom: 10px;
}
.form {
    margin: 10px 0 10px 0;
    width: 100%;
    flex-wrap: wrap;
    .form-item {
        margin-bottom: 10px;
        display: flex;
        .label {
            width: 130px;
            display: block;
            text-align: left;
            margin-right: 20px;
            font-size: 14px;
            color: #666e7b;
            flex: 0 0 130px;
        }
        .value {
            color: #272933;
            flex: 1;
        }
    }
}
</style>
